import { TableCell, TableRow } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRouteLocation } from '../../hooks/useRouteLocation'
import { formatIsoTimestampForLocation } from '../../utils/dateUtils'

interface AlarmTableEntryProps {
  alarmId: string
  category: string
  timestamp: string
}

export const AlarmTableEntry: FC<AlarmTableEntryProps> = ({ alarmId, category, timestamp }) => {
  const navigate = useNavigate()
  const location = useRouteLocation()

  const humanTimestamp = formatIsoTimestampForLocation(timestamp, location)

  return (
    <TableRow onClick={() => navigate(`./${alarmId}`)} data-testid="alarm-table-entry">
      <TableCell align="left" data-testid="alarm-table-entry-timestamp">
        {humanTimestamp}
      </TableCell>
      <TableCell align="left">{category}</TableCell>
      <TableCell align="left">{alarmId}</TableCell>
    </TableRow>
  )
}
